import { RoutesIcon } from './RoutesIcon';

/**
 * author: Austin Andrews
 * id 4E7234E7-AB5F-491D-BA6F-674B3BAD9027
 * name routes
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/routes.svg
 * tags
 */
export const SignRoutesIcon = RoutesIcon;
export default SignRoutesIcon